import React from 'react';
import { NavigationLinks } from '../../molecules/NavigationLinks/NavigationLinks';
import {StickyWrapper} from './StickyNavigationLinks.Styles';

interface StickyNavigationLinkProps {
    onSearch?: (tag: string) => void;
    tag?: string; // Adicionando a prop "tag"
}
const foo = () => {
  console.log('No search function provided');
};

export const StickyNavigationLink: React.FC<StickyNavigationLinkProps> = ({tag, onSearch}) => {
    
    return(
  <StickyWrapper>
    <NavigationLinks tag={tag} onSearch={onSearch || foo}/>
  </StickyWrapper>
)};